<div class="rib-l">
  <ng-container
    *ngTemplateOutlet="bridge.getSlot(`${id()}:left`)()"
  ></ng-container>
</div>
<div class="rib-c">
  <ng-container
    *ngTemplateOutlet="bridge.getSlot(`${id()}:center`)()"
  ></ng-container>
</div>
<div class="rib-r">
  <ng-container
    *ngTemplateOutlet="bridge.getSlot(`${id()}:right`)()"
  ></ng-container>
</div>
